import { ElementDto, OverlayTemplateDto } from "@repo/api/overlays";

export function generateNewElementExternalIds(template: OverlayTemplateDto) {
  const copiedTemplate = JSON.parse(JSON.stringify(template));

  for (const aspectRatio in copiedTemplate.content.elements) {
    copiedTemplate.content.elements[aspectRatio] = generateElementExternalIds(
      copiedTemplate.content.elements[aspectRatio]!,
    );
  }

  for (const aspectRatio in copiedTemplate.content.startScene) {
    copiedTemplate.content.startScene[aspectRatio]!.elements =
      generateElementExternalIds(
        copiedTemplate.content.startScene[aspectRatio]!.elements,
      );
  }

  for (const aspectRatio in copiedTemplate.content.endScene) {
    copiedTemplate.content.endScene[aspectRatio]!.elements =
      generateElementExternalIds(
        copiedTemplate.content.endScene[aspectRatio]!.elements,
      );
  }

  return copiedTemplate;
}

function generateElementExternalIds(elements: ElementDto[]) {
  return elements.map((element) => {
    element.externalId = crypto.randomUUID();
    return element;
  });
}
